<template>
  <f7-panel left reveal swipe class="panel-init" data-visible-breakpoint="800">
    <f7-page-content>
      <div id="panel-content">
        <f7-block class="text-align-center">
          <img src="~@/assets/img/Aio-Light-Transparent-200px.png" alt="aio* logo">
        </f7-block>
        <f7-list class="side-menu">
          <f7-list-group v-if="isManager">
            <f7-list-item :link="links.root" :title="$t('menu.budgets')" panel-close></f7-list-item>
            <f7-list-item :link="links.report" :title="$t('menu.reports')" panel-close
                          v-if="doesManageMaster"
            ></f7-list-item>
            <f7-list-item :link="links.manageRequests" :title="$t('menu.requests')" panel-close></f7-list-item>
          </f7-list-group>
          <f7-list-group>
            <f7-list-item :link="links.myCard" :title="$t('menu.myCard')" panel-close></f7-list-item>
            <f7-list-item :link="links.spend" :title="$t('menu.myTransactions')" panel-close></f7-list-item>
            <f7-list-item :link="links.myRequests" :title="$t('menu.myRequests')" panel-close></f7-list-item>
            <f7-list-item :link="links.profile" :title="$t('menu.myProfile')" panel-close></f7-list-item>
          </f7-list-group>
          <f7-list-group v-if="isAdmin">
            <f7-list-item :link="links.company" :title="$t('menu.company')" panel-close></f7-list-item>
            <f7-list-item :link="links.users" :title="$t('menu.users')" panel-close></f7-list-item>
          </f7-list-group>
          <f7-list-group>
            <f7-list-item :link="links.help" :title="$t('menu.help')" panel-close></f7-list-item>
            <f7-list-item :link="links.settings" :title="$t('menu.settings')" panel-close></f7-list-item>
            <f7-list-item :link="links.logout" :title="$t('menu.logout')" panel-close></f7-list-item>
          </f7-list-group>
        </f7-list>
      </div>
    </f7-page-content>
  </f7-panel>
</template>

<script>
  import helpers from '@/utils/helpers'

  export default {
    name: 'side-menu',
    mixins: [helpers],
  }
</script>

<style lang="scss">
  @import '@/sass/variables.scss';

  .ios .side-menu.list ul {
    background: none;
  }

  #panel-content {
    height: auto;
    min-height: 100vh;
    overflow: hidden;
    position: relative;

    --f7-list-chevron-icon-color: #c7c7cc;

    &::after {
      background-image: url("~@/assets/img/Aio-Texture-Asterisks-Salmon-Angle.svg");
      background-position: center 50vh;
      background-repeat: no-repeat;
      background-size: 100%;
      background-attachment: fixed;
      bottom: 0;
      content: '';
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .panel.panel-left {
    background: linear-gradient($salmon-sunrise1, $salmon-sunrise2, $salmon-sunrise3);

    img {
      width: 120px;
    }

    .side-menu {
      color: $white;
    }

    hr {
      border: 1px solid rgba(255, 255, 255, 0.5);
    }

    .link {
      color: $white;
      display: block;
      margin: 1em 0;
    }
  }

  /*@media (min-width: 768px) {*/
  /*.panel.panel-left.panel-reveal {*/
  /*border-right: 1px solid rgba(0, 0, 0, .1);*/
  /*width: 220px;*/
</style>
